import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { getTitle, getDescription } from './lib/helpers';
import { BreadCrumbsService } from './breadcrumbs.service';

@Component({
  selector: 'page-not-found',
  templateUrl: '../templates/page-not-found.component.html'
})
export class PageNotFoundComponent {
  constructor(
    private titleService: Title,
    private metaService: Meta,
    private breadCrumbsService: BreadCrumbsService,
  ) {
    this.titleService.setTitle(getTitle('404 - Страница не найдена'));
    this.metaService.updateTag({name: 'description', content: getDescription('404 - Страница не найдена')});

    this.breadCrumbsService.crumbs = [];
  }
}
